import { createContext } from 'react';

export const UserProfileContext = createContext(null);
